import React from 'react'

interface FormErrorMessageProps {
  error?: string
  className?: string
  isTextCenter?: boolean
}

const FormErrorMessage: React.FC<FormErrorMessageProps> = ({
  error,
  className = '',
  isTextCenter = false,
}) => {
  if (!error) return null

  return (
    <div
      className={`
        mt-10px
        font-pretendard
        font-regular
        text-14px
        text-semanticError
        ${isTextCenter ? 'text-center' : 'text-left'}
        ${className}
      `}
    >
      {error}
    </div>
  )
}

export default FormErrorMessage
